import * as React from 'react';
import { appContext } from '../../../../web/models/getHelp/appContext';
import { AwaMetaTagType, ContentAttribute, OcvMsaTenantId, SourceApps } from '../../../models/constants/constants';
import { IOcvState, IUITabViewInfo, UITabView, UITabViewInfo, UITabViewMode } from '../../../models/reduxState';
import '../../common/css/contactUs.scss';
import '../../common/css/help.scss';

import { getContactUsClassNames, IContactUsStyles } from '../styles/contactUsStyles';
import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';
import { InAppFeedbackInitOptions, initializeCentro, isCentroInitialized } from '../../../../web/utils/CentroOCVFeedbackSDK/CentroFeedbackFunctions';
import { InAppFeedbackScenarioType, FeedbackAuthenticationType, FeedbackAgeGroup } from '../../../../web/utils/CentroOCVFeedbackSDK/FeedbackTypes';
import { M365ThemeKind } from '../controls/customizations/styles/theme.types';

import { InitialFeedbackData as feedbackData } from '../../../../web/utils/CentroOCVFeedbackSDK/Initparameters';
import { captureContentUpdate } from '../../../../web/utils/oneDsUtil';
import { getMetaTagAttributeValue } from '../../../../web/utils/statelessUtil';
import { UserInfo } from '../../../models/apiModels';
import { IconButton, Link, mergeStyles } from '@fluentui/react';
import { getAppBarButtonStyles } from '../../../../web/self-help/styles/selfHelpStyles';
import { getBuildVersionString } from '../../../utilities';

/* eslint-disable promise/prefer-await-to-then */
export interface OcvComponentProps {
  sourceApp: SourceApps;
  isNonAgave: boolean;
  isTeams: boolean;
  isGetHelp: boolean;
  market: string;
  isSignedIn: boolean;
  userInfo: UserInfo;
  isMsa: boolean;
  isAad: boolean;
  shouldInitializeOcv: boolean;
  showOcv: boolean;
  ocvState: IOcvState;
  isDarkTheme: boolean;
  isFeedbackTicketCreationEnabled: boolean;
  isFeedbackCoachmarkEnabled: boolean;
  IsOcvVNextEnabled: boolean;
  isVLastInitialized: boolean;
  aimId: string;
  shouldSendAimId: boolean;

  // dispatchers
  dispatchShowCoachmark: () => void;
  dispatchGetAlchemyThemeRoutingData: () => Promise<void>;
  dispatchBypassThemeRouting: (value: string) => void;
  resetContactUsFocus: (value: boolean) => void;
  updateUITabViewInfo: (uiTabViewInfo: IUITabViewInfo) => void;
  setIsInitializedOcv: () => void;
  showTicketCreation: () => void;
  showCoachmark: () => void;
}


type IOcvComponentProps = OcvComponentProps & IStyledComponent<IContactUsStyles>;

export class OcvComponent extends React.Component<IOcvComponentProps, any> {
  public componentDidMount() {
    if (this.props.isGetHelp) {
      // For WebView2 user, initializing centro engine, include ocv in-app feedback SDK init
      // For WebView1 user, cause vNext won't' support WebView1, so WebView1 user will fallback to Feedback Hub
      if (navigator.userAgent.indexOf('Edg/') > -1 && appContext.showAboutAndFeedbackButtons) {
        initializeCentro(appContext.locale, true);
      }
    }
  }

  public componentWillUnmount = () => {
    if (!!window.OfficeBrowserFeedback && !!window.OfficeBrowserFeedback.floodgate && this.props.isVLastInitialized) {
      window.OfficeBrowserFeedback.floodgate.stop();
    }
  };

  public render() {
    const contactUsClassNames = getContactUsClassNames(this.props.styles, { theme: this.props.theme, sourceApp: this.props.sourceApp, isTeams: this.props.isTeams, isNonAgave: this.props.isNonAgave });
    return (
      <div>
        <div id="centroRef"></div>
        {this.props.isGetHelp ? (
          <IconButton
            iconProps={{ iconName: 'Feedback' }}
            aria-label={getString('AppBar_FeedbackButtonToolTip')}
            onClick={this.onOcvClicked}
            styles={getAppBarButtonStyles(this.props.theme)}
          />
        ) : (
          <Link
            key={'footer-ocv-link'}
            id='ocvFeedbackClicked'
            className={mergeStyles(contactUsClassNames.caption, contactUsClassNames.link)}
            data-bi-area='ContactUsFooter'
            data-bi-formnm='maxFunnel'
            data-bi-bhvr='CLICK'
            data-bi-name='ocvFeedbackClicked'
            onClick={this.onOcvClicked}
          >
            {getString('result_launchOcvButtonText')}
          </Link>
        )}
      </div>
    );
  }

  private onOcvClicked = async () => {
    if (this.props.IsOcvVNextEnabled) {
      try {
        await initializeCentro(this.props.market, this.props.isGetHelp);
      } catch (e: any) {
      }
    }

    if (this.props.shouldInitializeOcv && !isCentroInitialized()) {
      this.initializeVLast();
    }

    if (isCentroInitialized()) {
      feedbackData.feedbackConfig!.isDisplayed = true;
      feedbackData.feedbackConfig!.scenarioConfig = {
        isScenarioEnabled: true,
        scenarioType: InAppFeedbackScenarioType.Experience,
      };

      if (this.props.shouldSendAimId && !!this.props.aimId) {
        feedbackData.feedbackConfig.appData = 'AimId: ' + this.props.aimId;
      }

      if (this.props.isGetHelp) {
        feedbackData.feedbackConfig.appData =
          'OSVersion: ' +
          appContext.systemInfo.OsVersionString +
          ' AppVersion: ' +
          appContext.systemInfo.AppVersionString;

          if (this.props.shouldSendAimId && !!this.props.aimId) {
            feedbackData.feedbackConfig.appData += ' AimId: ' + this.props.aimId;
          }
      } else {
        // set config for smc
        feedbackData.appId = this.props.ocvState.AppId;
        feedbackData.clientName = 'SMC';
        feedbackData.feedbackConfig.isEmailCollectionEnabled = this.props.ocvState.ShowEmailAddress;
        feedbackData.feedbackConfig.isScreenshotEnabled = this.props.ocvState.ShowScreenshot;
        feedbackData.feedbackConfig.isScreenRecordingEnabled = this.props.ocvState.ShowScreenRecording;
        feedbackData.feedbackConfig.isFileUploadEnabled = this.props.ocvState.ShowFileUpload;
      }
      // if we want have category we need featureAreas parameter below
      // feedbackData.feedbackConfig.featureAreas = ['Display problem', 'Searching results', 'Accessibility problem', 'Other'];
      feedbackData.themeOptions = {
        baseTheme: this.props.isDarkTheme ? M365ThemeKind.M365Dark : M365ThemeKind.M365Light,
      };

      if (this.props.isSignedIn && !appContext.isCommercial) {
        feedbackData.authenticationType = FeedbackAuthenticationType.MSA;
        feedbackData.userId = this.props.userInfo?.UserPuid;
        if (this.props.userInfo?.LegalAgeGroup === 3) {
          feedbackData.ageGroup = FeedbackAgeGroup.Adult;
        } else {
          // include: homeState.userAgeGroup === 'Undef' or userAgeGroup === ''
          // means either user undefine their age
          // or user logged in but SMC getBasicUserInfo() API return error
          feedbackData.ageGroup = FeedbackAgeGroup.Undefined;
        }
      } else {
        // For unauthenticated user (log out customer and commercial),
        // userId will set as empty by default, and authentication Type
        // will be set as Unauthenticated means their feedback will
        // only be kept for 30 days by OCV
        feedbackData.authenticationType = FeedbackAuthenticationType.Unauthenticated;
        feedbackData.userId = '';
        feedbackData.ageGroup = FeedbackAgeGroup.Undefined;
      }

      if (this.props.isFeedbackTicketCreationEnabled || this.props.isFeedbackCoachmarkEnabled) {
        feedbackData.callbackFunctions.supportCallback = () => {
          if (this.props.isFeedbackTicketCreationEnabled) {
            this.showTicketCreation();
          }
          else if (this.props.isFeedbackCoachmarkEnabled) {
            this.showCoachmark();
          }

          // Get close OCV button
          const element = document.querySelector('[data-icon-name="InAppFeedbackCancel"]');
          if (element) {
            const parentElement = element.parentElement;
            if (parentElement) {
              parentElement.click();
            }
          }
        };
      }

      InAppFeedbackInitOptions.updateFeedbackObject(feedbackData);
    } else {
      if (!!window.OfficeBrowserFeedback) {
        window.OfficeBrowserFeedback.multiFeedback();
      } else {
        this.logOcvError(new Error('OCV is not initialized.'));
        if (this.props.isGetHelp) {
          // If centro initialization failed, fallback to previous feedback experience with Feedback Hub
          notifyParent(`{"command" : "LaunchFeedbackHub"}`);
        }
      }
    }
  };

  private showTicketCreation = (viewMode?: UITabViewMode) => {
    const uiTabViewInfo = new UITabViewInfo();
    uiTabViewInfo.uITabView = UITabView.requestCreation;
    if (viewMode) {
      uiTabViewInfo.viewMode = viewMode;
    }
    uiTabViewInfo.showAppBarBackButton = this.props.isGetHelp;
    this.props.dispatchGetAlchemyThemeRoutingData()
    this.props.dispatchBypassThemeRouting('');
    this.props.updateUITabViewInfo(uiTabViewInfo);
    this.props.resetContactUsFocus(true);
  }

  private showCoachmark = () => {
    this.props.dispatchShowCoachmark();
  }

  private logOcvError = (error: Error) => {
    const buildVersion = getMetaTagAttributeValue(AwaMetaTagType.BuildVersion, ContentAttribute);
    const logHandlerTags = {
      content: {
        contentId: 'ocvFeedbackError',
        contentName: 'ocvFeedbackError',
        buildVersion,
        formnm: 'maxFunnel',
        areaName: 'ContactUsFooter',
        fileName: 'ContactUsFooter.tsx',
        url: `${window.location.href}`,
        errorMessage: error,
      },
      behavior: 'OTHER',
    };
    captureContentUpdate(logHandlerTags);
  };

  private initializeVLast = async () => {
    const theme = this.props.theme;
    let initOptions;
    if (!!window.OfficeBrowserFeedback) {
      initOptions = {
        appId: this.props.ocvState.AppId,
        stylesUrl: this.props.ocvState.StylesUrl,
        intlUrl: this.props.ocvState.IntlUrl,
        environment: this.props.ocvState.Environment,
        primaryColour: theme.palette.themePrimary,
        secondaryColour: theme.palette.themeDarkAlt,
        userEmail: this.props.userInfo.MemberName,
        onError: (error: Error) => this.logOcvError(error),
        locale: this.props.market,
        ageGroup: this.props.userInfo.LegalAgeGroup,
        showEmailAddress: this.props.ocvState.ShowEmailAddress,
        screenshot: this.props.ocvState.ShowScreenshot,
        build: getBuildVersionString(),
        authenticationType: this.getOcvAuthenticationType(),
        isCommercialHost: !!this.props.isSignedIn && this.props.userInfo.Provider === 'OrgId',

        telemetryGroup: {
          loggableUserId: this.getFormattedUserId(),
          tenantId: this.getFormattedTenantId(),
        },
      };

      // Policy checks required for AAD users
      // AAD scenario is currently disabled 0/0/0
      if (!(this.props.isSignedIn && this.props.userInfo.Provider === 'WindowsLiveId')) {
        initOptions['emailPolicyValue'] = 0; // controls if user can include their email address
        initOptions['screenshotPolicyValue'] = 0; // controls if user can include screenshot
        initOptions['sendFeedbackPolicyValue'] = 0; // conftols if user can submit feedback
      }

      const sessionId = getMetaTagAttributeValue(AwaMetaTagType.CorrelationId, ContentAttribute);
      if (!!sessionId) {
        initOptions['sessionId'] = sessionId;
      }

      if (!!this.props.userInfo.Cid) {
        initOptions['cid'] = this.getFormattedCid();
      }

      window.OfficeBrowserFeedback.initOptions = initOptions;
      await window.OfficeBrowserFeedback.floodgate.initialize();
      window.OfficeBrowserFeedback.floodgate.start();
      this.props.setIsInitializedOcv();
    }
  };

  private getOcvAuthenticationType = (): number => {
    if (this.props.isSignedIn && !!this.props.userInfo) {
      if (this.props.userInfo.Provider === 'WindowsLiveId') {
        return 0;
      }
      if (this.props.userInfo.Provider === 'OrgId') {
        return 1;
      }
    }
    return 2;
  };

  private getFormattedCid = () => {
    return 'm:' + this.props.userInfo.Cid;
  };

  private getFormattedUserId = () => {
    if (!!this.props.userInfo.UserPuid) {
      let prefix;
      if (this.props.isMsa) {
        prefix = 'p:';
      } else if (this.props.isAad) {
        prefix = 'ap:';
      }
      return prefix + this.props.userInfo.UserPuid;
    }
    return '';
  };

  private getFormattedTenantId = () => {
    // default value for unauthenticated user and MSA user
    let tenantID;
    if (this.props.isMsa) {
      tenantID = OcvMsaTenantId;
    } else if (!!this.props.userInfo.TenantId && this.props.isAad) {
      // no prefix is needed for tenantID, except for empty tenantID
      tenantID = this.props.userInfo.TenantId;
    }
    return tenantID;
  };

}
